import { asWidgetProps } from 'Src/types/widget-helpers';
import React, { ComponentProps } from 'react';
import { CheckButton } from 'Components/frameworks/check-button/CheckButton';
import { Icon } from 'Components/frameworks/icon/Icon';
import { InputSwitch } from 'Components/frameworks/form-inputs/input-switch/InputSwitch';
type Props = FilterOptionProps & {
  className?: string;
  isButton?: boolean;
  name?: string;
  onChange: (value: string) => void;
};
export const FilterOption = ({
  className,
  iconName,
  iconSize,
  id,
  imageSrc,
  isButton,
  isDisabled,
  isIconNotSquare,
  isSelected,
  label,
  matched,
  name,
  onChange,
  subLabel,
  value,
}: Props) =>
  isButton ? (
    <CheckButton
      {...asWidgetProps<ComponentProps<typeof CheckButton>>({
        className: className,
        isChecked: isSelected,
        isDisabled: isDisabled,
        onClick: () => onChange(value as string),
      })}
    >
      {iconName && (
        <Icon
          {...asWidgetProps<ComponentProps<typeof Icon>>({
            className: 'mb-5',
            hasRtl: true,
            isNotSquare: isIconNotSquare,
            name: iconName,
            width: iconSize || '1.5rem',
          })}
        />
      )}
      {imageSrc && <img alt="" className="mb-5 w-4/5 max-w-100" src={imageSrc} />}
      {label}
      {subLabel && <span className="text-12 text-mediumGrey">{subLabel}</span>}
      <span className="text-12 text-black">({matched})</span>
    </CheckButton>
  ) : (
    <InputSwitch
      {...asWidgetProps<ComponentProps<typeof InputSwitch>>({
        className: className,
        id: id,
        isChecked: isSelected,
        isDisabled: isDisabled,
        label: (
          <span className="inline-flex items-center gap-5">
            {iconName && (
              <Icon
                {...asWidgetProps<ComponentProps<typeof Icon>>({ name: iconName, width: '1.5rem' })}
              />
            )}
            {label}
            {subLabel && <span className="text-12 text-mediumGrey">{subLabel}</span>}
            <span className="text-12 text-mediumGrey">({matched})</span>
          </span>
        ),
        name: name,
        onChange: () => onChange(value as string),
        value: value,
      })}
    />
  );
